import React from 'react';
import {supabase} from '@/services/supabaseClient';
import {loadDoctorPatientPhotos,releaseDoctorPatientPhotos} from '@/pages/doctors/appointments/lib/doctorPatientPhotos.js';
export default function usePatientPhotos(appointmentId){
 const [state,setState]=React.useState({items:[],access:'unavailable',loading:true});
 React.useEffect(()=>{
  let alive=true,items=[],running=false;const refresh=async()=>{if(running)return;running=true;
   const result=await loadDoctorPatientPhotos({appointmentId,previousItems:items});running=false;
   if(!alive){releaseDoctorPatientPhotos(result.items);return;}
   if(items!==result.items)releaseDoctorPatientPhotos(items);items=result.items;setState({...result,loading:false});
  };
  setState({items:[],access:'unavailable',loading:true});refresh();
  const timer=setInterval(refresh,5000);const focus=()=>refresh();
  window.addEventListener('focus',focus);
  const channel=supabase.channel(`photo-authority:${appointmentId}:${Math.random()}`).on('postgres_changes',{event:'*',schema:'public',table:'ehr_access_requests',filter:`appointment_id=eq.${appointmentId}`},()=>refresh()).subscribe();
  return()=>{alive=false;clearInterval(timer);window.removeEventListener('focus',focus);supabase.removeChannel(channel);releaseDoctorPatientPhotos(items);};
 },[appointmentId]);return state;
}
